import { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import BaseModal from 'components/Modals/BaseModal';

export default function AddServiceModal({ show, onClose, onAdd, availableServices = [] }) {
  const [selectedName, setSelectedName] = useState('');

  useEffect(() => {
    if (show) {
      setSelectedName('');
    }
  }, [show]);

  const handleSubmit = () => {
    if (!selectedName) return;
    onAdd(selectedName);
    onClose();
  };

  return (
    <BaseModal
      show={show}
      handleShow={onClose}
      size="md"
      title="Add Service"
      backgroundColor="#1a2124"
      borderColor="#56577A"
      borderWidth={1}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={!selectedName}>
            Add Service
          </Button>
        </>
      }
    >
      <Form>
        <Form.Group controlId="addServiceTemplate">
          <Form.Label className="text-white">Choose a service to add</Form.Label>
          <Form.Select value={selectedName} onChange={(e) => setSelectedName(e.target.value)}>
            <option value="">Select a service</option>
            {availableServices.map((service) => (
              <option key={service.name} value={service.name}>
                {service.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Form>
    </BaseModal>
  );
}
